<template>
  <div class="wrapper">
    <div class="title">{{ title }}</div>
    <div class="range-wrap">
      <input
        type="range"
        name=""
        id=""
        v-model="value"
        :min="min"
        :max="max"
        :step="step"
      />
      <label>{{ minlabel }}</label>
      <label>{{ maxlabel }}</label>
    </div>
  </div>
</template>

<script>
import { store } from "@/store/scene.js";
export default {
  name: "Range",
  components: {},
  props: ["title", "prop", "min", "max", "step", "minlabel", "maxlabel"],
  data() {
    return {
      value: 0,
      store,
    };
  },
  mounted() {
    if (store[this.prop]) this.value = store[this.prop];
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal !== oldVal) store[this.prop] = +this.value;
    },
  },
};
</script>

<style scoped>
.title {
  font-size: 2rem;
  letter-spacing: -0.6px;
}
.value {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.range-wrap {
  position: relative;
  margin-bottom: 2rem;
}
.range-wrap label {
  position: absolute;
  bottom: -75%;
}
.range-wrap label:first-of-type {
  left: 0;
}
.range-wrap label:last-of-type {
  right: 0;
}
input[type="range"] {
  margin-top: 2rem;
  -webkit-appearance: none;
  width: 100%;
  background: transparent;
  display: inline-flex;
  justify-content: center;
  position: relative;
}
input[type="range"]:before,
input[type="range"]:after {
  content: "";
  display: inline-block;
  height: 2rem;
  width: 2px;
  background: white;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
input[type="range"]:before {
  left: 0;
}
input[type="range"]:after {
  right: 0;
}
input[type="range"]:focus {
  outline: none;
}
input[type="range"]::-webkit-slider-runnable-track {
  -webkit-appearance: none;
  width: 100%;
  height: 2px;
  cursor: pointer;
  background: white;
}
input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  border: 2px solid #000000;
  height: 2.5rem;
  width: 2.5rem;
  border-radius: 50%;
  cursor: pointer;
  background: white;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
</style>